var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPersonalcard = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/personalcard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "personalcard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.168 17.5H5.83464C2.5013 17.5 1.66797 16.6667 1.66797 13.3333V6.66667C1.66797 3.33333 2.5013 2.5 5.83464 2.5H14.168C17.5013 2.5 18.3346 3.33333 18.3346 6.66667V13.3333C18.3346 16.6667 17.5013 17.5 14.168 17.5Z",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.668 6.66699H15.8346",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5 10H15.8333",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.168 13.333H15.8346",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.08255 9.40827C7.91558 9.40827 8.59089 8.73296 8.59089 7.89993C8.59089 7.0669 7.91558 6.3916 7.08255 6.3916C6.24952 6.3916 5.57422 7.0669 5.57422 7.89993C5.57422 8.73296 6.24952 9.40827 7.08255 9.40827Z",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.0013 13.6085C9.88464 12.4001 8.9263 11.4501 7.71797 11.3418C7.3013 11.3001 6.8763 11.3001 6.4513 11.3418C5.24297 11.4585 4.28464 12.4001 4.16797 13.6085",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPersonalcard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/personalcard.3b1bf0ed.svg";
export { ForwardRef as ReactComponent };